import { inject, observer } from 'mobx-react';
import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import styled from 'styled-components';

import { TokenStore, UserStore } from '../stores';
import { AuthStore } from '../stores/authStore';

import { Spin } from 'antd';
import { DefaultPage } from './DefaultPage';

interface PrivateRouteProps extends RouteProps {
    component: React.ComponentType<any>;
    path: string;
    userStore?: UserStore;
    authStore?: AuthStore;
    tokenStore?: TokenStore;
}

const SpinWrapper = styled.div`
    text-align: center;
    padding-top: 200px;
`;

@inject('userStore')
@inject('tokenStore')
@observer
class PrivateRoute extends React.Component<PrivateRouteProps, {}> {
    async componentWillMount() {
        const { userStore } = this.props;
        if (this.props.tokenStore!.autenticado) {
            await userStore!.getAcciones();
        }
    }

    render() {
        const { path, component, userStore, tokenStore, authStore } = this.props;
        const { isGettingActions } = userStore!;
        const { autenticado } = tokenStore!;

        return isGettingActions ? (
            <SpinWrapper>
                <Spin spinning={true} size="large" />
            </SpinWrapper>
        ) : autenticado ? (
            userStore!.estaAutorizado ? (
                 <Route path={path} component={component} />
            ) : (
                <Redirect to="/" />
            )
        ) : (
            // tslint:disable-next-line: jsx-no-lambda
            <Route render={() => <DefaultPage />} />
        );
    }
}

export default PrivateRoute;
